import { render, staticRenderFns } from "./KeyPal2Instructions.vue?vue&type=template&id=14d992c3&scoped=true&"
import script from "./KeyPal2Instructions.vue?vue&type=script&lang=js&"
export * from "./KeyPal2Instructions.vue?vue&type=script&lang=js&"
import style0 from "./KeyPal2Instructions.vue?vue&type=style&index=0&id=14d992c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d992c3",
  null
  
)

export default component.exports